import { createFileRoute } from "@tanstack/react-router";
import { getCmsLegalPage } from "@/lib/cms/website.functions";
import { LegalPageView, legalHead } from "@/components/cms/LegalPageView";

const SLUG = "privacy-policy";
const FALLBACK = "Privacy Policy";

export const Route = createFileRoute("/privacy-policy")({
  loader: () => getCmsLegalPage({ data: { slug: SLUG } }),
  head: ({ loaderData }) => legalHead(loaderData ?? null, FALLBACK, `/${SLUG}`),
  component: () => <LegalPageView page={Route.useLoaderData()} fallbackTitle={FALLBACK} />,
});
